import {
  Card,
  CardContent,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import TaskPicker from '../../components/TaskPicker';
import { playNow } from '../../redux/draft';
import dateUtil from '../../util/dateUtil';
var datefns = require('date-fns');

const useStyles = makeStyles((theme) => ({}));

const EventCard = ({ event, timecardId, title }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [showDialog, setShowDialog] = useState(false);
  const [domain, setDomain] = useState('');
  const [prefilter, setPrefilter] = useState('');

  if (!event) return '';

  const formatDate = (isoDate) => {
    return datefns.format(datefns.parseISO(isoDate + 'Z'), 'hh:mm a');
  };

  const getDomain = (emailAddress) => {
    if (!emailAddress) return null;
    try {
      return emailAddress.split('@')[1].toLowerCase();
    } catch (e) {
      return null;
    }
  };

  if (showDialog) {
    return (
      <TaskPicker
        onClose={() => setShowDialog(false)}
        preFilter={domain || prefilter}
        defaultView="flat"
        onSelect={(item) => {
          setShowDialog(false);
          dispatch(
            playNow(
              {
                ...item,
                description: 'Meeting: ' + event.subject,
                startTime: dateUtil.toTimeString(new Date(event?.start?.dateTime + 'Z')),
              },
              timecardId
            )
          );
        }}
      />
    );
  } else {
    return (
      <Grid
        xs={12}
        item
        style={{ cursor: 'pointer', margin: 4 }}
        onClick={() => {
          let taskId;
          if (event.bodyPreview.indexOf('taskid:') != -1) {
            var rx = /taskid:(\d*)/i;
            taskId = rx.exec(event.bodyPreview)[1];
          }

          if (taskId) {
            setPrefilter('taskid:' + taskId);
            setShowDialog(true);
          } else {
            //if no task, look for an email address to filter the list
            var domain = getDomain(event.organizer.emailAddress.address);
            if (domain == 'gennet.com' || domain == 'compass365.com') {
              const outsideAttendee = event.attendees.find((attendee) => {
                domain = getDomain(attendee.emailAddress.address);
                if (domain != 'gennet.com' && domain != 'compass365.com') return true;
              });
              if (outsideAttendee) {
                domain = getDomain(outsideAttendee.emailAddress.address);
              }
            }
            if (domain) setDomain(domain);
            else setDomain('');
            setShowDialog(true);
          }
        }}
      >
        <Card className={classes.card}>
          <CardContent>
            <Grid container>
              {title && (
                <Grid item xs={12}>
                  <Typography>{title}</Typography>
                </Grid>
              )}
              <Grid item xs={12}>
                <Typography color="primary">{event.subject}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>Start: {formatDate(event.start.dateTime)}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>End: {formatDate(event.end.dateTime)}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>Click to record time</Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    );
  }
};

export default EventCard;
